export default {
  default: () => import("D:/www/aparecidanp/aparecidanp.com.br/layouts/default.vue").then(m => m.default || m)
}